import React, { useState, useEffect } from "react";

export default function NotFound() {
    return (
        <div className="Home">
            Not Found
        </div>
    );
}